import script from "./GlobalNoticePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalNoticePopup.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalNoticePopup.vue?vue&type=style&index=0&id=e834d4b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9e49b3956b2acc83467a459eac1f916e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e834d4b2"]])

export default __exports__